import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"
import { IMChatOverviewItem } from "../components/IMChatOverviewItem"
import Loader from "../components/Loader"
import { rootStore } from "../StApp"
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../services/DexieDbImpl"
import { PotMatchIndic } from "../components/PotMatchIndic"
import { MatchTrayItem } from "../components/MatchTrayItem"
import PullToRefresh from "react-simple-pull-to-refresh"
import { delay } from "../services/HelperService"
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";
import { DumpsIndic } from "../components/DumpsIndic"

const MatchTray = observer(() => {

    const [store] = useState(rootStore.matchStore)

    return (<div className='flex-row' style={{
        height: 120,
        width: '100%',
        overflow: 'scroll'
    }}>
        <PotMatchIndic />
        <ul className='flex-row center-align ' style={{flexGrow: 1}} >
            {store.matches.map(item => <MatchTrayItem user={item} />)}
        </ul>
        <DumpsIndic/>
    </div>);
})


const IMChatOverview = () => {

    const chatListStore = rootStore.imChatListStore
    const [store] = useState(rootStore.matchStore)

    const chatList = useLiveQuery(() => db.getAllChats())

    useEffect(() => {

        store.loadPotMatches()

    }, [])

    useEffect(() => {

        store.loadNewMatches()

    }, [])

    useEffect(() => {

        chatListStore.loadChats()

    }, [])

    async function refreshPage() {

        chatListStore.loadChats()
        store.loadNewMatches(true)
        store.loadPotMatches(true)

        await delay(1000)

    }

    function getChats() {

        switch (chatListStore.loadProg) {

            case 'LOADING': return <Loader />

            case 'SUCCESS':
                if (chatList != undefined && chatList?.length < 1)
                    return (
                        <div className='flex-column center-both' style={{ height: '70%' }} >
                            <p>You don't have any Chats yet :/</p>
                            <p>Stay patient, they're on their way :)</p>
                        </div>
                    )
                else
                    return (
                        <>
                            <ul>
                                {
                                    chatList?.map(item => (<IMChatOverviewItem item={item} key={item.lastMsgTime} />))
                                }
                            </ul>
                        </>
                    )

            default: return <p>FAILED</p>
        }

    }



    return (

        <motion.div className='absolute' style={{ height:'100%', width:'100%', overflow:'scroll' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <PullToRefresh className='relative' onRefresh={refreshPage} pullDownThreshold={100} maxPullDownDistance={100} >
                <div className='flex-column' style={{margin: 8}} >
                    <h4>Match Queue</h4>
                    <MatchTray />
                    <h4>Conversations</h4>
                    {getChats()}
                </div>
            </PullToRefresh>
        </motion.div>

    )


}

export default observer(IMChatOverview)